export default __webpack_public_path__ + "static/pack_shadow-7fa60d7cdc04046925721afa7a7be6dc.png";